import { string, func } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const AriesAvatarIcon = ({ fill, height, onClick, viewBox, width, ...rest }) => {
    return (
        <SvgIcon
            width={width}
            fill={fill}
            height={height}
            onClick={onClick}
            viewBox={viewBox}
            {...rest}
        >
            <path
                fill={fill}
                d="M16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16S24.84,0,16,0ZM14.15,20.52l-.57,1.59c-.05.14-.26.14-.31,0l-.57-1.59c-.64-1.77-2.03-3.16-3.8-3.8l-1.59-.57c-.14-.05-.14-.26,0-.31l1.59-.57c1.77-.64,3.16-2.03,3.8-3.8l.57-1.59c.05-.14.26-.14.31,0l.57,1.59c.64,1.77,2.03,3.16,3.8,3.8l1.59.57c.14.05.14.26,0,.31l-1.59.57c-1.77.64-3.16,2.03-3.8,3.8ZM23.76,22.92l-.81.29c-.89.32-1.6,1.03-1.92,1.92l-.29.81c-.03.07-.13.07-.16,0l-.29-.81c-.32-.89-1.03-1.6-1.92-1.92l-.81-.29c-.07-.03-.07-.13,0-.16l.81-.29c.89-.32,1.6-1.03,1.92-1.92l.29-.81c.03-.07.13-.07.16,0l.29.81c.32.89,1.03,1.6,1.92,1.92l.81.29c.07.03.07.13,0,.16ZM23.76,9.23l-.81.29c-.89.32-1.6,1.03-1.92,1.92l-.29.81c-.03.07-.13.07-.16,0l-.29-.81c-.32-.89-1.03-1.6-1.92-1.92l-.81-.29c-.07-.03-.07-.13,0-.16l.81-.29c.89-.32,1.6-1.03,1.92-1.92l.29-.81c.03-.07.13-.07.16,0l.29.81c.32.89,1.03,1.6,1.92,1.92l.81.29c.07.03.07.13,0,.16Z"
            />
        </SvgIcon>
    );
};

AriesAvatarIcon.propTypes = {
    fill: string,
    height: string,
    onClick: func,
    viewBox: string,
    width: string,
};

AriesAvatarIcon.defaultProps = {
    fill: MIGRATED_COLORS.chatAvatarBase,
    height: '32',
    onClick: () => {},
    viewBox: '0 0 32 32',
    width: '32',
};

export default AriesAvatarIcon;
